import { useAtomValue, useSetAtom } from "jotai";
import {
    tagsAtom,
    sortedTagsAtom,
    tagKeysAtom,
    tagsByKeyAtom,
    tagIdToKeyValueMapAtom,
    tagsQueryAtom,
    refetchTagsAtom,
} from "../state/tagAtoms";
import { tagApiService } from "../services/tagApiService";
import { serializeKeyValue } from "../utils/tag-utils";

export function useTags() {
    const tags = useAtomValue(tagsAtom);
    const sortedTags = useAtomValue(sortedTagsAtom);
    const tagKeys = useAtomValue(tagKeysAtom);
    const tagsByKey = useAtomValue(tagsByKeyAtom);
    const tagIdMap = useAtomValue(tagIdToKeyValueMapAtom);
    const queryState = useAtomValue(tagsQueryAtom);
    const refetch = useSetAtom(refetchTagsAtom);
    const loading = queryState.isFetching;

    const refreshTags = async () => {
        await refetch();
    };

    const createTag = async (key: string, value: string) => {
        const keyValue = serializeKeyValue(key, value);
        const newTag = await tagApiService.createTag(keyValue);
        await refetch();
        return newTag;
    };

    const updateTag = async (tagId: string, key: string, value: string) => {
        const keyValue = serializeKeyValue(key, value);
        await tagApiService.updateTag(tagId, keyValue);
        await refetch();
    };

    const removeTag = async (tagId: string) => {
        await tagApiService.deleteTag(tagId);
        await refetch();
    };

    return {
        tags,
        sortedTags,
        tagKeys,
        tagsByKey,
        tagIdMap,
        loading,
        refreshTags,
        createTag,
        updateTag,
        removeTag,
    };
}
